import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import { Link } from 'gatsby'

import MainLayout from '../components/Layouts/MainLayout'
import Seo from '../components/seo'
import Ticker from '../components/Ticker'
import WaveContainer from '../components/Layouts/WaveContainer'

const Index = ({ data }) => {
    // default States
    const [memberCount, setMemberCount] = useState(0)
    const [twitchCount, setTwitchCount] = useState(0)
    const [trovoCount, setTrovoCount] = useState(0)
    const [youtubeCount, setYoutubeCount] = useState(0)
    const [twitterCount, setTwitterCount] = useState(0)
    const [tiktokCount, setTiktokCount] = useState(0)
    const [instagramCount, setInstagramCount] = useState(0)
    const [allCount, setAllCount] = useState(0)

    //trigger once
    useEffect(() => {
        getStats()
    }, [])

    const getStats = () => {
        let memberZahl = 0
        let twitch = 0
        let trovo = 0
        let youtube = 0
        let twitter = 0
        let tiktok = 0
        let instagram = 0
        data.allStrapiMember.nodes.map(member => {
            memberZahl++
            if (member.Twitch !== null) {
                if (member.Twitch.Follower !== null) {
                    twitch = twitch + member.Twitch.Follower
                }
            }
            if (member.Trovo !== null) {
                if (member.Trovo.Follower !== null) {
                    trovo = trovo + member.Trovo.Follower
                }
            }
            if (member.Youtube !== null) {
                if (member.Youtube.Abonnenten !== null) {
                    youtube = youtube + member.Youtube.Abonnenten
                }
            }
            if (member.Twitter !== null) {
                if (member.Twitter.Follower !== null) {
                    twitter = twitter + member.Twitter.Follower
                }
            }
            if (member.TikTok !== null) {
                if (member.TikTok.Follower !== null) {
                    tiktok = tiktok + member.TikTok.Follower
                }
            }
            if (member.Instagram !== null) {
                if (member.Instagram.Follower !== null) {
                    instagram = instagram + member.Instagram.Follower
                }
            }
        })

        setMemberCount(memberZahl)
        twitch = Math.round(twitch / 10) * 10
        setTwitchCount(twitch)
        trovo = Math.round(trovo / 10) * 10
        setTrovoCount(trovo)
        youtube = Math.round(youtube / 10) * 10
        setYoutubeCount(youtube)
        twitter = Math.round(twitter / 10) * 10
        setTwitterCount(twitter)
        tiktok = Math.round(tiktok / 10) * 10
        setTiktokCount(tiktok)
        instagram = Math.round(instagram / 10) * 10
        setInstagramCount(instagram)
        setAllCount(twitch + trovo + youtube + twitter + tiktok + instagram)
    }
    return (
        <MainLayout>
            <Seo title="Home" />
            <main id="main">
                <section
                    id="hero"
                    className="bg-gray-900 grid grid-cols-1 xl:grid-cols-2 py-24 xl:py-36 min-h-[100vh] relative"
                >
                    <div
                        data-sal="slide-right"
                        data-sal-delay="300"
                        data-sal-easing="ease"
                        data-sal-duration="1000"
                        className="w-auto flex items-center justify-center pb-16 xl:pb-0 px-2 md:px-0"
                    >
                        <div className="block ">
                            <h1 className="tracking-tight font-extrabold text-white text-5xl md:text-6xl text-center lg:text-left">
                                <span>
                                    Willkommen bei <br />
                                </span>
                                <span className="gradientText">SAFE SPARK</span>
                            </h1>
                            <p className="mt-3 text-base text-gray-400 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0 text-justify font-normal">
                                Das Safe Spark Network ist ein {''}
                                <span className="font-extrabold">
                                    Neues Content-Creator Netzwerk
                                </span>
                                , das für dich geschaffen wurde. <br />
                                <br />
                                Wir sind{' '}
                                <span className="font-extrabold">
                                    kein Follow for Follow Netzwerk
                                </span>{' '}
                                und keine einfache Community. <br />
                                <br />
                                Das Safe Spark Network vermittelt den
                                Content-Creatorn{' '}
                                <span className="font-extrabold">
                                    Partnerschaften
                                </span>
                                , veranstaltet zukünftig{' '}
                                <span className="font-extrabold">
                                    gemeinsame Streams
                                </span>{' '}
                                auf den Netzwerkkanälen,{' '}
                                <span className="font-extrabold">
                                    repostet euch auf den Netzwerk Socials
                                </span>{' '}
                                und{' '}
                                <span className="font-extrabold">
                                    unterstützt bestmöglich bei allen Fragen
                                </span>{' '}
                                rund ums Streamen.
                            </p>
                            <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                <div className="rounded-md shadow">
                                    <a
                                        href="#Vorteile"
                                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient md:py-4 md:text-lg md:px-10"
                                    >
                                        Erfahre Mehr
                                    </a>
                                </div>
                                <div className="mt-3 sm:mt-0 sm:ml-3">
                                    <Link
                                        to="/Kontakt#Bewerbung"
                                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md  bg-gray-200 hover:bg-white md:py-4 md:text-lg md:px-10 transition ease-in-out duration-300"
                                    >
                                        <span className="gradientText">
                                            Bewirb Dich
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-auto flex justify-center items-center flex-col pb-40 xl:pb-0">
                        <img
                            className="w-3/4 lg:w-1/2 xl:w-3/4 h-auto"
                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Safe-Spark_Logo.webp"
                            alt="Safe-Spark Logo"
                        />
                        <div className="socialIcons flex gap-5 sm:gap-8 px-9 w-full sm:w-3/4 lg:w-1/2 xl:w-3/4 2xl:w-[60%] pt-8">
                            {/* <a
                                href="https://trovo.live/SafeSparkNetwork"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Trovo.webp"
                                    alt="Logo Trovo"
                                />
                            </a> */}
                            <a
                                href="https://twitter.com/safespark_net"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Twitter.webp"
                                    alt="Logo Twitter"
                                />
                            </a>
                            <a
                                href="https://www.twitch.tv/safesparknetwork"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Twitch.webp"
                                    alt="Logo Twitch"
                                />
                            </a>
                            <a
                                href="https://www.youtube.com/channel/UCVaRvM7SsLkEIlbvsxGQTxA"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Youtube.webp"
                                    alt="Logo Youtube"
                                />
                            </a>
                            <a
                                href="https://www.tiktok.com/@safesparknetwork"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/TikTok.webp"
                                    alt="Logo TikTok"
                                />
                            </a>
                            <a
                                href="https://www.instagram.com/safespark_net/"
                                className="basis-full"
                            >
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Insta.webp"
                                    alt="Logo Instagram"
                                />
                            </a>
                        </div>
                    </div>
                </section>

                <WaveContainer ID="Vorteile">
                    <div
                        data-sal="slide-up"
                        data-sal-easing="ease"
                        data-sal-duration="1000"
                        className="bg-gray-900 w-full md:w-[95%] xl:w-5/6 2xl:w-3/4 text-gray-100 shadow-md rounded-2xl grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 gap-y-10 px-4 md:px-16 py-12 md:py-20 my-8 place-content-center"
                    >
                        <h2 className="text-center col-span-full text-4xl sm:text-5xl pb-5 font-bold">
                            Deine Vorteile
                        </h2>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Netzwerk.webp"
                                    alt="Netzwerkk"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Vernetze Dich mit Anderen
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Hilfe.webp"
                                    alt="Hilfe"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Unterstützung bei Technischen Fragen
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Projekte.webp"
                                    alt="Projekte"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Projekte und Events durch das Netzwerk
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Vertrag.webp"
                                    alt="Vertrag"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Optionale Vertragsbindung
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Herz.webp"
                                    alt="Tolerant"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Tolerant und Akzeptabel
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Partnerschaft.webp"
                                    alt="Partnerschaft"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Möglichkeiten auf Partnerschaften
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Transparent.webp"
                                    alt="Transparent"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Transparentes Netzwerkmanagement
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Key.webp"
                                    alt="Gamekeys"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Möglichkeit auf Kostenlose Gamekeys
                                </h4>
                            </div>
                        </div>
                        <div className="benefit flex gap-3 items-center justify-center">
                            <div className="basis-1/5">
                                <img
                                    src="https://shop-the-easycode.de/Bilder/Safe-Spark/Repost.webp"
                                    alt="Reposting"
                                    className="w-full h-auto"
                                />
                            </div>
                            <div className="basis-4/5">
                                <h4 className="uppercase font-bold pb-3">
                                    Reposting deiner Posts in den Sozialen
                                    Medien
                                </h4>
                            </div>
                        </div>
                    </div>
                </WaveContainer>

                <section className="bg-gray-900 min-h-[30vh] relative">
                    <div
                        id="stats"
                        className="items-center justify-center flex"
                    >
                        <div className="pt-52 pb-20 grid grid-cols-4 text-gray-100 uppercase place-content-center max-w-6xl px-4">
                            <div className="col-span-full">
                                <h2 className="text-center col-span-full text-4xl sm:text-5xl pb-16 font-bold">
                                    Netzwerk Statistiken
                                </h2>
                            </div>
                            <div className="col-span-full md:col-span-4 pb-10 md:pb-0">
                                <div className="flex flex-col items-center justify-center">
                                    <img
                                        src="https://shop-the-easycode.de/Bilder/Safe-Spark/Twitch.webp"
                                        alt="Logo Twitch"
                                        className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                    />
                                    <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                        <Ticker
                                            className="count"
                                            end={twitchCount}
                                            suffix="+"
                                        />
                                    </div>
                                    <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                        Follower auf Twitch
                                    </h3>
                                </div>
                            </div>
                            {/* <div className="col-span-full md:col-span-2 pb-10 md:pb-0">
                                <div className="flex flex-col items-center justify-center">
                                    <img
                                        src="https://shop-the-easycode.de/Bilder/Safe-Spark/Trovo.webp"
                                        alt="Logo Trovo"
                                        className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                    />
                                    <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                        <Ticker
                                            className="count"
                                            end={trovoCount}
                                            suffix="+"
                                        />
                                    </div>
                                    <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                        Follower auf Trovo
                                    </h3>
                                </div>
                            </div> */}

                            <div className="col-span-full grid grid-cols-4 md:pt-20 gap-6">
                                <div className="col-span-4 md:col-span-2 lg:col-span-1 pb-10 md:pb-0">
                                    <div className="flex flex-col items-center justify-center">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Youtube.webp"
                                            alt="Logo Youtube"
                                            className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                        />
                                        <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                            <Ticker
                                                className="count"
                                                end={youtubeCount}
                                                suffix="+"
                                            />
                                        </div>
                                        <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                            Abonnenten auf YouTube
                                        </h3>
                                    </div>
                                </div>
                                <div className="col-span-4 md:col-span-2 lg:col-span-1 pb-10 md:pb-0">
                                    <div className="flex flex-col items-center justify-center">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/TikTok.webp"
                                            alt="Logo TikTok"
                                            className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                        />
                                        <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                            <Ticker
                                                className="count"
                                                end={tiktokCount}
                                                suffix="+"
                                            />
                                        </div>
                                        <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                            Follower auf TikTok
                                        </h3>
                                    </div>
                                </div>
                                <div className="col-span-4 md:col-span-2 lg:col-span-1 md:pt-20 lg:pt-0 pb-10 md:pb-0">
                                    <div className="flex flex-col items-center justify-center">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Insta.webp"
                                            alt="Logo Instagram"
                                            className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                        />
                                        <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                            <Ticker
                                                className="count"
                                                end={instagramCount}
                                                suffix="+"
                                            />
                                        </div>
                                        <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4 ">
                                            Follower auf Instagram
                                        </h3>
                                    </div>
                                </div>
                                <div className="col-span-4 md:col-span-2 lg:col-span-1 md:pt-20 lg:pt-0 pb-10 md:pb-0">
                                    <div className="flex flex-col items-center justify-center">
                                        <img
                                            src="https://shop-the-easycode.de/Bilder/Safe-Spark/Twitter.webp"
                                            alt="Logo Twitter"
                                            className="w-auto h-[60px] md:h-[70px] lg:h-[90px]"
                                        />
                                        <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                            <Ticker
                                                className="count"
                                                end={twitterCount}
                                                suffix="+"
                                            />
                                        </div>
                                        <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                            Follower auf Twitter
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-full md:col-span-2 pt-20">
                                <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                    <Ticker
                                        className="count"
                                        end={memberCount}
                                    />
                                </div>
                                <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                    Netzwerkmitglieder
                                </h3>
                            </div>
                            <div className="col-span-full md:col-span-2 pt-20">
                                <div className="text-center text-xl md:text-2xl lg:text-3xl text-[#e2800f] font-bold pt-4">
                                    <Ticker
                                        className="count"
                                        end={allCount}
                                        suffix="+"
                                        duration={4}
                                    />
                                </div>
                                <h3 className="text-center text-xl md:text-2xl lg:text-3xl text-gray-100 font-bold pt-4">
                                    Follower insgesamt
                                </h3>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </MainLayout>
    )
}

export const query = graphql`
    {
        allStrapiMember(filter: {}) {
            totalCount
            nodes {
                Youtube {
                    Abonnenten
                }
                TikTok {
                    Follower
                }
                Trovo {
                    Follower
                }
                Twitch {
                    Follower
                }
                Twitter {
                    Follower
                }
                Instagram {
                    Follower
                }
            }
        }
    }
`

export default Index
